import { render, staticRenderFns } from "./ProductListingCreate.vue?vue&type=template&id=22aef907&"
import script from "./ProductListingCreate.vue?vue&type=script&lang=js&"
export * from "./ProductListingCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports